var map = {
	"./default-avatar.png": 244637,
	"./emoji-32.png": 630778,
	"./empty-chat.png": 6089,
	"./fmc.jpg": 759046,
	"./ic_high.svg": 100342,
	"./ic_highest.svg": 16114,
	"./ic_low.svg": 958364,
	"./ic_medium.svg": 691534,
	"./ic_preview.svg": 376548,
	"./icon_move.svg": 346508,
	"./icon_surplus.svg": 201107,
	"./intelligent-recommend-empty@2x.png": 789441,
	"./mini_program.png": 837375,
	"./novice-guide-1.png": 171638,
	"./novice-guide-2.png": 517447,
	"./novice-guide-3.png": 362167,
	"./novice-guide-4.png": 976230,
	"./novice-guide-bg.png": 802637,
	"./novice-guide-last.png": 401842,
	"./novice-guide-next.png": 608411,
	"./pop-guide-1.png": 543438,
	"./pop-guide-2.png": 654106,
	"./pop-guide-3.png": 42178,
	"./pop-guide-4.png": 529891,
	"./pop-guide-5.png": 958584,
	"./pop-guide-6.png": 495205,
	"./pop-guide-last.png": 343650,
	"./pop-guide-next.png": 758394,
	"./robot_call_upgrade.png": 591870,
	"./start-chat.png": 799786,
	"./zhongtong.png": 375052,
	"./zhongtong_signin.png": 468575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 798381;